function dataLayerContainer() {
    const dataLayerScript = document.createElement('script');
    dataLayerScript.type = 'text/javascript';
    dataLayerScript.defer="";
    dataLayerScript.innerHTML = `
        var dev = false;
        var JDPjs = JDPjs || {}; 
        JDPjs.DTMData = JDPjs.DTMData || {}; 
        JDPjs.DTMData.pageName = 'Cars/Compare-Cars'; 
        JDPjs.DTMData.prop35 = 'Cars/Compare-Cars'; 
        JDPjs.DTMData.prop9 = 'Cars'; 
        JDPjs.DTMData.prop36 = '2002'; 
        JDPjs.DTMData.prop59 = '/cars/compare-cars'; 
        JDPjs.DTMData.eVar3 = '/cars/compare-cars'; 
        JDPjs.DTMData.prop60 = 'https://www.jdpower.com/cars/compare-cars '; 
        window.optimizely = window.optimizely || []; 
        window.optimizely.push("activateSiteCatalyst");
        function InsertDTMData(key, value) { 
            JDPjs.DTMData[key] = value; 
        }
    `;

    document.head.appendChild(dataLayerScript);

    const gtmScript = document.createElement('script');
    gtmScript.src = "https://assets.adobedtm.com/eb71467bd0d7/2c2bc4303cc0/launch-a1981e9fb178.min.js";
    gtmScript.async = true;

    document.head.appendChild(gtmScript);
}

function metadataContainer() {
    const metadataScript = document.createElement('meta');
    metadataScript.name = "robots";
    metadataScript.content = "noindex, nofollow";

    document.head.appendChild(metadataScript);
}

export { dataLayerContainer, metadataContainer };